import {
  ADD_GAME_ROLE,
  DESTROY_GAME_ROLE,
  UPDATE_GAME_ROLE,
} from '../constants/action-types'

const initialState = {
  list: INITIAL.game_roles || {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_GAME_ROLE:
    case UPDATE_GAME_ROLE: {
      const gameRoleId = action.payload.id
      const gameRoleData = action.payload

      return {
        ...state,
        list: {
          ...state.list,
          [gameRoleId]: gameRoleData
        }
      }
    }
    case DESTROY_GAME_ROLE: {
      const { [action.payload.id]: _, ...withoutGameRole } = state.list

      return {
        ...state,
        list: withoutGameRole,
      }
    }
    default:
      return state
  }
}